var _defs, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 240",
    width: 320,
    height: 240,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 0 L 0 0 0 24",
    stroke: "#fff",
    strokeOpacity: 0.17,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gm",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gmask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#gm)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E25B5B",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#E25B5B",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E25B5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ag",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5a5a66"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ab",
    viewBox: "0 0 8 8",
    refX: 7,
    refY: 4,
    markerWidth: 5,
    markerHeight: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .8 L7 4 L0 7.2 Z",
    fill: "#5082ef"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#g)",
    mask: "url(#gmask)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 221.4,
    y1: 123.5,
    x2: 164.4,
    y2: 174.3,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 164.4,
    y1: 174.3,
    x2: 107.3,
    y2: 138.3,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 107.3,
    y1: 138.3,
    x2: 112.5,
    y2: 87.1,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 112.5,
    y1: 87.1,
    x2: 163.7,
    y2: 67.2,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 163.7,
    y1: 67.2,
    x2: 156.3,
    y2: 127.1,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 156.3,
    y1: 127.1,
    x2: 143.3,
    y2: 110.7,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 143.3,
    y1: 110.7,
    x2: 221.4,
    y2: 123.5,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 221.4,
    y1: 123.5,
    x2: 112.5,
    y2: 87.1,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 164.4,
    y1: 174.3,
    x2: 143.3,
    y2: 110.7,
    stroke: "#3a3a44",
    strokeWidth: 1.4,
    strokeOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.4,
    cy: 174.3,
    r: 30,
    fill: "url(#glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.3,
    cy: 127.1,
    r: 26,
    fill: "url(#glow)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.4,
    cy: 123.5,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.3,
    cy: 138.3,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 87.1,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.7,
    cy: 67.2,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.3,
    cy: 110.7,
    r: 7,
    fill: "#41414a",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.4,
    cy: 174.3,
    r: 7,
    fill: "#E25B5B",
    stroke: "#E25B5B",
    strokeWidth: 1.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.3,
    cy: 127.1,
    r: 7,
    fill: "#E25B5B",
    stroke: "#E25B5B",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRisk);
export default __webpack_public_path__ + "static/media/high-risk.c38e49bbd2242329af7ccd1675c5e199.svg";
export { ForwardRef as ReactComponent };